import { Pipe, PipeTransform } from '@angular/core';

/**
 * Pipe to join an array of objects or strings. By default it uses ', ' as separator and 'name' as attribute name.
 */
@Pipe({
  name: 'join'
})
export class JoinPipe implements PipeTransform {
  transform(value: any[], separator: string = ', ', attributeName: string = 'name'): string {
    if (!Array.isArray(value)) {
      return value;
    }
    const isArrayOfObjects = value.every(item => typeof item === 'object' && item !== null);

    if (isArrayOfObjects) {
      return value.map(item => item[attributeName]).join(separator);
    }
    return value.join(separator);
  }

}